// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.x-data {
    list-style-type: none;
    padding-left: 0;
}

ul.x-data li {
    position: relative;
    padding-left: 20px;
}

ul.x-data li::before {
    content: "X";
    position: absolute;
    left: 0;
    color: lightcoral;
}
`, "",{"version":3,"sources":["webpack://./src/styles/List.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,iBAAiB;AACrB","sourcesContent":["ul.x-data {\n    list-style-type: none;\n    padding-left: 0;\n}\n\nul.x-data li {\n    position: relative;\n    padding-left: 20px;\n}\n\nul.x-data li::before {\n    content: \"X\";\n    position: absolute;\n    left: 0;\n    color: lightcoral;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
